var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"wrapper-base-overlined-heading"}},[_c('svg',[_c('rect',{attrs:{"id":"Rectangle_85","data-name":"Rectangle 85","width":"103","height":"3","fill":_vm.color}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }